<template>
    <div class="global-filter-list global-filter-list--vue">
        <span class="filter-label" :class="{ 'filter-label--always': alwaysShowFilterLabel }">{{filterLabel}}</span>
        <div class="filter--list filter__head" @click="toggleBody" v-if="selectedOption">
            <button class="filter filter--secondary icon--after icon--absolute" :class="{ 'icon--arrow-down': !open, 'icon--arrow-up': open }">
                {{selectedOption.title}} <span class="counter" v-if="typeof selectedOption.count !== 'undefined'">({{selectedOption.count}})</span>
            </button>
        </div>
        <ul class="filter--list filter__body" :style="open ? 'display: block': ''">
            <li v-for="option in options" :key="option.value">
                <a href="#" class="filter filter--secondary" :class="{ active: isActive(option) }" @click="selectOption(option, $event)">
                    {{option.title}} <span class="counter" v-if="typeof option.count !== 'undefined'">({{option.count}})</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export const propOptions = {
    mode: ['horizontal', 'vertical'],
    headerType: ['headline-2', 'headline-3'],
    tabType: ['text', 'filter']
};

export default {
    name: "global-filter-list",
    props: {
        filterLabel: {
            type: String,
            default: ''
        },
        alwaysShowFilterLabel: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: [],
            validator: (prop) => prop.every((option, i) => {
                    if (typeof option !== 'object') {
                        console.warn(`Expecting an array of objects - found something different at position ${i}`, typeof option, option);
                        return false;
                    }
                    if (typeof option.value === 'undefined') {
                        console.warn(`Object at position ${i} did not have a value property`, option);
                        return false;
                    }
                    if (!option.title) {
                        console.warn(`Object at position ${i} did not have a title property`, option);
                        return false;
                    }
                    // && option.count // count is optional and displayed in brackets after the title
                    return true;
                }
            ),
        },
        active: null // Value matching an option of the identical option object
    },
    data: function () {
        return {
            open: false
        }
    },
    computed: {
        selectedOption() {
            if (this.options.length > 0) {
                let selection = undefined;
                if (typeof this.active !== 'undefined') {
                    selection = this.options.find(option => option === this.active ||this.active === option.value);
                }
                if (selection === undefined) {
                    selection = this.options[0];
                }
                return selection;
            }
            return null;
        }
    },
    methods: {
        isActive(option) {
            return this.selectedOption === option;
        },
        selectOption(selectedOption, event) {
            event.preventDefault();
            this.$emit('select', selectedOption);
            this.open = false;
        },
        toggleBody(event) {
            event.stopPropagation();

            this.open = !this.open;
        },
    },
}
</script>
